export class URLUtils {
  static addQueryParams(url: string, params: { [key: string]: string }): string {
    const urlObject = new URL(url);
    Object.entries(params).forEach(([key, value]) => {
      urlObject.searchParams.set(key, value);
    });
    return urlObject.toString();
  }
}
